export default __webpack_public_path__ + "static/media/asphalt.0274fb68.jpg";